export const unsecureProtocol = 'http://';
